import styled from "styled-components";

export const StyledBody = styled.div`
  height: 100%;
  @media (min-width: 800px) {
    background: #fff;
  }
`;